import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log('GetSurveyQuestions', payload);
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(config).apiMethod({
                method: 'GetSurveyQuestions',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: {
                    ...payload,
                },
                urlArgs: {
                    survey_id: payload ? payload.survey_id : null,
                },
            });

            if (!result.success) {
                if (result.errorText) {
                    return {
                        ...result,
                        isError: true,
                        error: result.errorText,
                    };
                } else if (result.code) {
                    return {
                        ...result,
                        success: false,
                        isError: true,
                        error: result.data,
                    };
                }
            } else {
                return {
                    ...result,
                    isError: false,
                    error: {},
                };
            }
        } else {
            return {};
        }
    };
};
